(() => {
  const root = document.documentElement;
  const scrollingElement = document.scrollingElement || root;
  let newOverlayJustRegistered = false;
  let newOverlayJustRegisteredTimer;
  let overlayStack = [];
  const focusableElems = window.swinger.focusableElements;
  const overlaysCreated = new Map();

  const activateBackdrop = () => {
    root.classList.add('overlay-open');
    window.swinger.$('main, main footer', document.body)
      .forEach((elem) => elem.setAttribute('inert', ''));
    if (!window.CSS || !window.CSS.supports('overscroll-behavior: contain')) {
      Object.assign(scrollingElement.style, {
        position: 'fixed',
        top: `-${window.scrollY || window.pageYOffset}px`,
        touchAction: 'pinch-zoom',
        scrollBehavior: 'auto',
      });
    }
  };

  const deactivateBackdrop = () => {
    root.classList.remove('overlay-open');
    window.swinger.$('main, main footer', document.body)
      .forEach((elem) => elem.removeAttribute('inert'));
    if (!window.CSS || !window.CSS.supports('overscroll-behavior: contain')) {
      const scrollY = scrollingElement.style.top;
      Object.assign(scrollingElement.style, {
        position: '',
        top: '',
        touchAction: '',
      });
      scrollingElement.scrollTop = parseInt(scrollY || '0', 10) * -1;
      scrollingElement.style.scrollBehavior = '';
    }
  };

  window.swinger = {
    ...window.swinger,
    overlayManager: {
      overlayStack,
      register: (overlayElem, overlayCloseFn, triggerElem, noModal) => {
        const isModal = !noModal;

        window.swinger.eventHub.trigger(document, 'swinger.overlay:open', {
          elem: overlayElem,
        });

        overlayStack = overlayStack.filter((overlay) => document.documentElement.contains(overlay.elem));

        if (isModal && !root.classList.contains('overlay-open')) {
          activateBackdrop();
        }

        overlayStack = overlayStack.filter((overlay) => overlay.elem !== overlayElem);

        overlayStack.push({
          elem: overlayElem,
          closeFn: overlayCloseFn,
          triggerElem,
        });

        newOverlayJustRegistered = true;
        window.clearTimeout(newOverlayJustRegisteredTimer);
        newOverlayJustRegisteredTimer = window.setTimeout(() => {
          newOverlayJustRegistered = false;
        }, 200);
      },
      unregister: (overlayElem) => {
        window.swinger.eventHub.trigger(document, 'swinger.overlay:close', {
          elem: overlayElem,
        });

        overlayStack = overlayStack
          .filter((overlay) => document.documentElement.contains(overlay.elem))
          .filter((overlay) => overlay.elem !== overlayElem);

        if (!overlayStack.length && root.classList.contains('overlay-open')) {
          deactivateBackdrop();
        }
      },
      close: (overlayElem) => {
        if (typeof overlayElem === 'string') {
          overlayElem = document.getElementById(`swinger-overlay-${overlayElem}`) || document.getElementById(overlayElem);
        }

        if (!overlayElem) {
          return false;
        }

        window.swinger.navigationHelper.releaseNav(overlayElem);
        window.swinger.overlayManager.unregister(overlayElem);

        const overlayId = overlayElem.getAttribute('id');

        if (overlayId) {
          const invoker = document.querySelector(`[aria-controls="${overlayId}"][data-invoker]`);

          // console.log({ invoker });

          if (invoker) {
            invoker.focus();
          }
        }

        window.requestAnimationFrame(() => {
          try {
            if (overlayElem.close) {
              overlayElem.close();
            } else {
              overlayElem.removeAttribute('open');
            }
          } catch (e) {
            console.log('Catched error while trying to work with native <dialog> element', e);
          }
          window.swinger.visibility.hide(overlayElem);
        });

        return true;
      },
      open: (overlayElem) => {
        if (typeof overlayElem === 'string') {
          overlayElem = document.getElementById(`swinger-overlay-${overlayElem}`) || document.getElementById(overlayElem);
        }

        if (!overlayElem) {
          return false;
        }

        const closeFn = () => {
          window.swinger.overlayManager.close(overlayElem);
        };

        try {
          if (overlayElem.showModal) {
            overlayElem.showModal();
          } else {
            overlayElem.setAttribute('open', '');
          }
        } catch (e) {
          console.log('Catched error while trying to work with native <dialog> element', e);
        }

        window.setTimeout(() => {
          let firstFocusableElem;

          try {
            firstFocusableElem = overlayElem.querySelector(
              focusableElems
                .map((selector) => `${selector}:not(:-webkit-autofill):not(:autofill)`)
                .join(','),
            );
          } catch (e) {
            firstFocusableElem = overlayElem.querySelector(
              focusableElems
                .join(','),
            );
          }

          if (firstFocusableElem) {
            firstFocusableElem.focus({ preventScroll: true });
          }
        }, 300);

        window.swinger.overlayManager.register(overlayElem, closeFn);
        window.swinger.navigationHelper.captureNav(overlayElem);

        return closeFn;
      },
      create: (options) => new Promise((resolve) => {
        const {
          type, initialState,
        } = options;

        initialState.startOpened = true;

        let overlayWidget = overlaysCreated.get(type);
        const overlayInitialized = !!overlayWidget;

        overlayWidget = window.swinger.widgets[overlayWidget ? 'replace' : 'create']({
          type,
          initialState,
        }, overlayWidget);

        overlaysCreated.set(type, overlayWidget);

        if (!overlayInitialized) {
          (
            document.getElementById('swinger-append-container')
            || window.swinger.$('body', document)[0]
          ).appendChild(overlayWidget);
        } else {
          const overlay = overlayWidget.firstChild;
          window.swinger.overlayManager.open(overlay);
        }

        const callback = (e) => {
          const elem = e.detail.elem;

          if (elem && elem.matches(`.swinger-overlay-${type}`)) {
            document.removeEventListener('swinger.overlay:open', callback);
            document.body.style.cursor = '';
            resolve();
          }
        };

        document.addEventListener('swinger.overlay:open', callback);
      }),
    },
  };

  window.swinger.eventHub.register('click', document, (e) => {
    if (!overlayStack.length || newOverlayJustRegistered) {
      return;
    }

    const clickedElement = window.swinger.eventHub.getTarget(e);
    const topmostOverlay = overlayStack[overlayStack.length - 1];

    if (topmostOverlay.elem.querySelectorAll('[class$="__close"]').length === 0) {
      return;
    }

    if (clickedElement.matches('.swinger-overlay-backdrop')) {
      topmostOverlay.closeFn();
      return;
    }

    if (
      overlayStack.find((entry) => entry.triggerElem && entry.triggerElem.contains(clickedElement))
      || topmostOverlay.elem.contains(clickedElement)
      || clickedElement.closest('button')
      || clickedElement.closest('[role="button"]')
      || (clickedElement.getRootNode && clickedElement.getRootNode() !== document)
    ) {
      return;
    }

    topmostOverlay.closeFn();
  });

  document.addEventListener('keydown', (e) => {
    const { activeElement } = document;

    if (!overlayStack.length) {
      return;
    }

    if (activeElement.matches('select, [contenteditable], label')) {
      return;
    }

    try {
      if (activeElement.matches('input:read-write, textarea') && activeElement.value) {
        return;
      }
    } catch (e) {
      // noop
    }

    switch (e.key) {
      default:
        return;

      case 'Up':
      case 'ArrowUp':
      case 'Down':
      case 'ArrowDown':
      case ' ':
        // Prevent keyboard scroll
        if (overlayStack.length) {
          e.preventDefault();
        }
        return;

      case 'Escape':
      case 'Esc': {
        if (!overlayStack.length) {
          return;
        }
        const topmostOverlayElem = overlayStack[overlayStack.length - 1].elem;
        const topmostOverlayElemId = topmostOverlayElem.id;
        const isCloseable = topmostOverlayElem.hasAttribute('data-close-label')
          || !!topmostOverlayElem.querySelector('[class$="__close"],[data-close-label]')
          || !!document.querySelector(`[aria-controls="${topmostOverlayElemId}"]`);

        // If overlay is not closeable
        if (!isCloseable) {
          return;
        }
      }
        break;
    }

    const topmostOverlay = overlayStack[overlayStack.length - 1];

    if (topmostOverlay.closeFn && typeof topmostOverlay.closeFn === 'function') {
      topmostOverlay.closeFn();
    }
  });
})();
